export default {
    methods: {
        socLogin(
            first_name,
            last_name,
            fb_id,
            picture,
            email,
            social_name,
            promise = 0
        ) {
            NProgress.start();
            this.$http({
                method: "post",
                url: `/api/loginWithSocial`,
                data: {
                    first_name,
                    last_name,
                    fb_id,
                    email,
                    picture,
                    promise,
                    social_name
                }
            }).then(res => {
                NProgress.done();
                if (res.data.message == "new_user") {
                    swal("new user created");
                } else if (res.data.message == "merge") {
                    swal("Your accounts has merged");
                } else if (res.data.message == "email_exists") {
                    swal({
                        title: "Are you sure?",
                        text: "Email exist",
                        icon: "warning",
                        buttons: {
                            cancel: "verify old",
                            catch: {
                                text: "delete create new",
                                value: "catch"
                            }
                        },
                        dangerMode: true
                    }).then(willDelete => {
                        if (willDelete) {
                            this.socLogin(
                                first_name,
                                last_name,
                                fb_id,
                                picture,
                                email,
                                social_name,
                                1
                            );
                        } else {
                            swal("please verify email");
                        }
                    });
                }
                if (res.data.user) {
                    this.$store.commit("user", res.data.user);
                    this.$store.commit("loginModal", false);
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./resources/js/components/share/functions.js